<div class="dashboard-container">
  <main class="dashboard-content">
    <div class="top-grid">
      <div [hidden]="dailyConsumptions().length == 0 && !initialLoading()" class="kpi-hero">
        <div class="card main-kpi daily-readings-chart-card">
          @if (dailyHourlyConsumptionsError()) {
            <p-message
              severity="error"
              styleClass="daily-readings-load-error-notice"
              [text]="dailyHourlyConsumptionsError()!"
            />
          }
          <div
            [hidden]="configForm.controls['formatType'].value == '1'"
            #chartContainer
            class="chartContainer"
          ></div>
          <div
            [hidden]="configForm.controls['formatType'].value == '0'"
            #chartContainer2
            class="chartContainer2"
          ></div>
          @if (hasEstimatedConsumptionsDaily() && !dailyHourlyConsumptionsError()) {
            <p class="daily-readings-chart-caption">
              <span class="daily-readings-chart-caption__key">
                <span
                  class="daily-readings-chart-caption__swatch"
                  [style.background-color]="getColorByType()"
                  aria-hidden="true"
                ></span>
                Consumo real
              </span>
              <span class="daily-readings-chart-caption__key">
                <span
                  class="daily-readings-chart-caption__swatch daily-readings-chart-caption__swatch--estimated"
                  [style.background-color]="getEstimatedBarColor()"
                  aria-hidden="true"
                ></span>
                Consumo estimado
              </span>
              <span class="daily-readings-chart-caption__text">
                En el periodo seleccionado hay consumos estimados basados en lecturas reales.
              </span>
            </p>
          }

          @if (initialLoading()) {
            <div class="daily-readings-chart-skeleton" aria-busy="true">
              <p-skeleton width="100%" height="100%" borderRadius="4px" />
            </div>
          }
        </div>
      </div>
      @if (dailyHourlyConsumptionsError()) {
        <div class="empty-insight daily-readings-error-insight">
          <lucide-icon name="circle-alert" [size]="36"></lucide-icon>
          <h3>No se pudieron cargar los consumos</h3>
          <p>{{ dailyHourlyConsumptionsError() }}</p>
        </div>
      } @else if (dailyConsumptions().length == 0 && !initialLoading()) {
        <div class="empty-insight">
          @if (loading == false) {
            <lucide-icon name="trending-down" [size]="36"></lucide-icon>

            <h3>No hay consumo en este periodo</h3>

            <p>Este suministro no tiene registros en las fechas seleccionadas.</p>

            <div class="suggestions">
              <span>
                <lucide-icon name="lightbulb" [size]="16"></lucide-icon>
                Sugerencias:</span
              >
              <ul>
                <li>Amplía o modifica el rango de fechas</li>
                <li>Verifica el suministro seleccionado</li>
                <li>Verifica el contador seleccionado</li>
              </ul>
            </div>
          }
        </div>
      }
      <div class="side-panel-2 daily-readings-config-wrap">
        <div class="config-container" [formGroup]="configForm">
          <header class="panel-header">
            <lucide-icon name="Settings2" [size]="20"></lucide-icon>
            <h3>Panel de configuración</h3>
          </header>
          <section class="form-section">
            <div class="field mb-4">
              <label class="block mb-1 text-sm font-medium text-secondary"
                >Tipo de Suministro</label
              >
              @if (hasSingleSupply()) {
                <div class="identity-badge">
                  <lucide-icon name="Droplets" [size]="14"></lucide-icon>
                  <span>{{ supplies()[0].supplyName }}</span>
                </div>
              } @else {
                <p-select
                  [options]="supplies()"
                  formControlName="supplyType"
                  optionLabel="supplyName"
                  placeholder="Seleccione suministro"
                  class="w-full custom-select"
                  (onChange)="onSupplyTypeChange($event)"
                  appendTo="body"
                >
                  <ng-template #selectedItem let-selectedOption>
                    <div class="flex align-items-center gap-2" *ngIf="selectedOption">
                      <lucide-icon name="Droplets" [size]="14"></lucide-icon>
                      <span>{{ selectedOption.supplyName }}</span>
                    </div>
                  </ng-template>
                </p-select>
              }
            </div>

            <div class="field mb-4">
              <label class="block mb-1 text-sm font-medium text-secondary"
                >Contador / Ubicación</label
              >
              @if (hasSingleMeter()) {
                <div class="identity-badge identity-badge--meter">
                  <span>Nº de módulo: {{ meterModuleNumber(meters()[0]) }}</span>
                  @if (meters()[0].location) {
                    <span class="identity-badge__loc">{{ meters()[0].location }}</span>
                  }
                </div>
              } @else {
                <p-select
                  [options]="meters()"
                  formControlName="meter"
                  optionLabel="serialNumber"
                  placeholder="Seleccione contador"
                  class="w-full custom-select"
                  (onChange)="onMeterChange($event)"
                  [emptyMessage]="
                    configForm.get('supplyType')?.value
                      ? 'No hay contadores'
                      : 'Seleccione un suministro primero'
                  "
                  appendTo="body"
                >
                  <ng-template #selectedItem let-selectedOption>
                    @if (selectedOption) {
                      <div class="meter-selected">
                        <span class="font-medium"
                          >Nº de módulo: {{ meterModuleNumber(selectedOption) }}</span
                        >
                        @if (selectedOption.location) {
                          <span class="m-loc">{{ selectedOption.location }}</span>
                        }
                      </div>
                    }
                  </ng-template>
                  <ng-template #item let-meter>
                    <div class="meter-item flex flex-column w-full gap-1">
                      <span class="m-sn">Nº de módulo: {{ meterModuleNumber(meter) }}</span>
                      @if (meter.location) {
                        <span class="m-loc">{{ meter.location }}</span>
                      }
                    </div>
                  </ng-template>
                </p-select>
              }
            </div>

            <div class="field mb-4">
              <label class="block mb-1 text-sm font-medium text-secondary">Vista</label>
              <div class="segmented" role="group" aria-label="Tipo de lecturas">
                <button
                  type="button"
                  class="segmented__btn"
                  [class.is-active]="!isHourlyView"
                  [attr.aria-pressed]="!isHourlyView"
                  (click)="selectView('0')"
                >
                  Lecturas diarias
                </button>
                <span
                  class="segmented__slot"
                  pTooltip="Este contador no ofrece lecturas horarias"
                  [tooltipDisabled]="isHourlyReadingsAvailable()"
                  tooltipPosition="top"
                >
                  <button
                    type="button"
                    class="segmented__btn"
                    [class.is-active]="isHourlyView"
                    [attr.aria-pressed]="isHourlyView"
                    [disabled]="!isHourlyReadingsAvailable()"
                    (click)="selectView('1')"
                  >
                    Lecturas horarias
                  </button>
                </span>
              </div>
            </div>

            @if (!isHourlyView) {
              <div class="field mb-4">
                <label class="block mb-1 text-sm font-medium text-secondary">Agrupación</label>
                <div class="segmented segmented--frequency" role="group" aria-label="Agrupación">
                  @for (option of frequencyType; track option.value) {
                    <button
                      type="button"
                      class="segmented__btn"
                      [class.is-active]="
                        configForm.controls['frequencyType'].value === option.value
                      "
                      [attr.aria-pressed]="
                        configForm.controls['frequencyType'].value === option.value
                      "
                      (click)="selectFrequency(option.value)"
                    >
                      {{ option.label }}
                    </button>
                  }
                </div>
              </div>

              <div formArrayName="comparativas" class="date-list">
                <div formGroupName="0" class="date-row-group">
                  <div class="card-title">
                    <lucide-icon name="Activity" [size]="18"></lucide-icon>
                    <h4>
                      Periodo
                      <span
                        class="custom-tooltip-trigger"
                        data-tooltip="El rango máximo de selección es de 2 años."
                      >
                        <i class="info-icon-circle">i</i>
                      </span>
                    </h4>
                  </div>

                  <div class="quick-dates" role="group" aria-label="Fecha rápida">
                    @for (option of quickDateOptions; track option.label) {
                      <button
                        type="button"
                        class="quick-dates__chip"
                        [class.is-active]="isQuickDateActive(option)"
                        [attr.aria-pressed]="isQuickDateActive(option)"
                        (click)="applyQuickDate(option)"
                      >
                        {{ option.label }}
                      </button>
                    }
                  </div>

                  <div class="input-grid">
                    <div class="field">
                      <label class="block mb-1 text-sm font-medium text-secondary">Inicio</label>
                      <p-datepicker
                        formControlName="inicio"
                        dateFormat="dd/mm/yy"
                        [showIcon]="true"
                        (onSelect)="onDateChange(0, 'inicio'); clearDateRangeYearWarning()"
                        (onYearChange)="onInicioYearChange($event, 0)"
                        (onMonthChange)="onInicioMonthChange($event, 0)"
                        (onClose)="clearDateRangeYearWarning()"
                        iconDisplay="input"
                        [minDate]="minDate"
                        [maxDate]="comparativas.at(0).get('fin')?.value || maxDate"
                        placeholder="dd/mm/aaaa"
                        appendTo="body"
                        styleClass="w-full"
                      >
                      </p-datepicker>
                    </div>

                    <div class="field">
                      <label class="block mb-1 text-sm font-medium text-secondary">Fin</label>
                      <p-datepicker
                        formControlName="fin"
                        dateFormat="dd/mm/yy"
                        [showIcon]="true"
                        (onSelect)="onDateChange(0, 'fin')"
                        [minDate]="comparativas.at(0).get('inicio')?.value || minDate"
                        [maxDate]="maxDate"
                        iconDisplay="input"
                        placeholder="dd/mm/aaaa"
                        appendTo="body"
                        styleClass="w-full"
                      >
                      </p-datepicker>
                      @if (showDateRangeYearWarning()) {
                        <small class="date-range-year-warning"
                          >El rango máximo permitido es de 2 años.</small
                        >
                      }
                    </div>
                  </div>
                </div>
              </div>
            } @else {
              <div formArrayName="comparativas" class="date-list">
                <div formGroupName="0" class="date-row-group">
                  <div class="card-title">
                    <lucide-icon name="Activity" [size]="18"></lucide-icon>
                    <h4>Día</h4>
                  </div>
                  <div class="day-nav">
                    <button
                      type="button"
                      class="day-nav__step"
                      aria-label="Día anterior"
                      [disabled]="!canShiftHourlyDay(-1)"
                      (click)="shiftHourlyDay(-1)"
                    >
                      <lucide-icon name="chevron-left" [size]="18"></lucide-icon>
                    </button>
                    <p-datepicker
                      formControlName="inicio"
                      dateFormat="dd/mm/yy"
                      [showIcon]="true"
                      (onSelect)="onHourlyDaySelect()"
                      iconDisplay="input"
                      [minDate]="minDate"
                      [maxDate]="maxDate"
                      placeholder="dd/mm/aaaa"
                      appendTo="body"
                      styleClass="w-full"
                    >
                    </p-datepicker>
                    <button
                      type="button"
                      class="day-nav__step"
                      aria-label="Día siguiente"
                      [disabled]="!canShiftHourlyDay(1)"
                      (click)="shiftHourlyDay(1)"
                    >
                      <lucide-icon name="chevron-right" [size]="18"></lucide-icon>
                    </button>
                  </div>
                </div>
              </div>
            }
          </section>

          <div class="action-footer">
            @if (!isHourlyView) {
              <p-button
                severity="secondary"
                outlined="true"
                label="Limpiar"
                (onClick)="resetConfig()"
                class="w-100"
                styleClass="w-100 btn-clear-filters"
                [style]="{ width: '100%' }"
              />

              <span
                pTooltip="Por favor, seleccione un rango de fechas válido."
                [tooltipDisabled]="!configForm.invalid"
                tooltipPosition="top"
              >
                <p-button
                  severity="primary"
                  outlined="true"
                  label="Buscar"
                  [disabled]="configForm.invalid"
                  (onClick)="applyConfig()"
                  class="w-100"
                  styleClass="w-100 btn-apply-filters"
                  [style]="{ width: '100%' }"
                />
              </span>
            }
          </div>

          <div class="summary-card">
            <div class="card-title">
              <lucide-icon name="Activity" [size]="18"></lucide-icon>
              <h4>Resumen de la búsqueda</h4>
            </div>

            <div class="summary-rows">
              <div class="s-row">
                <span class="s-label">Consumo medio del período</span>
                <span class="s-value">{{ resumen.avg }} {{ resumen.units }}</span>
              </div>

              <div class="s-row-complex">
                <div class="s-label">Consumo máximo:</div>
                <div class="s-sublabel">{{ resumen.maxLabel }}</div>
                <div class="s-value">{{ resumen.maxV }} {{ resumen.units }}</div>
              </div>

              <div class="s-row-complex">
                <div class="s-label">Consumo mínimo:</div>
                <div class="s-sublabel">{{ resumen.minLabel }}</div>
                <div class="s-value">{{ resumen.minV }} {{ resumen.units }}</div>
              </div>

              <div class="s-row total">
                <span class="s-label">Consumo total del período</span>
                <span class="s-value">{{ resumen.total }} {{ resumen.units }}</span>
              </div>
            </div>
          </div>
        </div>
        @if (initialLoading()) {
          <div class="daily-readings-config-skeleton-overlay config-skeleton" aria-busy="true">
            <div class="config-skeleton-header">
              <p-skeleton shape="circle" size="20px" />
              <p-skeleton width="65%" height="16px" />
            </div>
            <div class="config-skeleton-section">
              <p-skeleton width="55%" height="12px" styleClass="mb-2" />
              <p-skeleton width="100%" height="38px" borderRadius="6px" />
            </div>
            <div class="config-skeleton-section">
              <p-skeleton width="55%" height="12px" styleClass="mb-2" />
              <p-skeleton width="100%" height="38px" borderRadius="6px" />
            </div>
            <div class="config-skeleton-section">
              <p-skeleton width="55%" height="12px" styleClass="mb-2" />
              <p-skeleton width="100%" height="38px" borderRadius="6px" />
            </div>
            <div class="config-skeleton-date-block">
              <p-skeleton width="65%" height="16px" styleClass="mb-3" />
              <p-skeleton width="100%" height="38px" borderRadius="6px" />
            </div>
            <div class="config-skeleton-summary">
              <p-skeleton width="65%" height="16px" styleClass="mb-3" />
              @for (row of [1, 2, 3]; track row) {
                <div class="config-skeleton-summary-row" aria-hidden="true">
                  <p-skeleton width="70%" height="12px" />
                  <p-skeleton width="80px" height="14px" />
                </div>
              }
            </div>
          </div>
        }
      </div>
    </div>

    <div class="daily-readings-table-wrap">
      <p-card class="mt-3 mb-3 mt-xl-0 my-xl-0 daily-readings-table-card">
        <div class="d-flex flex-wrap justify-content-between align-items-center gap-2">
          <div class="fw-bold fs-5">Listado de consumos y lecturas</div>
          <p-splitbutton
            label="Exportar"
            icon="pi pi-download"
            [model]="exportMenuItems"
            [disabled]="exportDisabled()"
            severity="secondary"
            outlined="true"
            size="small"
            expandAriaLabel="Elegir formato de exportación"
            appendTo="body"
            (onClick)="exportReadings('csv')"
          />
        </div>

        @if (!tableInitialized()) {
          <div class="daily-readings-table-skeleton-overlay skeleton-table" aria-busy="true">
            <div class="skeleton-table-header daily-readings-table-row-4" aria-hidden="true">
              <p-skeleton width="75%" height="12px" />
              <p-skeleton width="75%" height="12px" />
              <p-skeleton width="75%" height="12px" />
              <p-skeleton width="75%" height="12px" />
            </div>
            @for (row of [1, 2, 3, 4, 5, 6]; track row) {
              <div class="skeleton-table-row daily-readings-table-row-4" aria-hidden="true">
                <p-skeleton width="75%" height="12px" />
                <p-skeleton width="75%" height="12px" />
                <p-skeleton width="75%" height="12px" />
                <p-skeleton width="75%" height="12px" />
              </div>
            }
          </div>
        }

        <p-table
          #consumptionTable
          [value]="visibleDailyConsumptionsTable()"
          stripedRows
          [scrollable]="consumptionsTableScrollable"
          [scrollHeight]="consumptionsTableScrollHeight"
          [size]="'small'"
          [tableStyle]="consumptionsTableStyle"
          [styleClass]="consumptionsTableStyleClass"
          [rowsPerPageOptions]="isHourlyView ? undefined : consumptionsTableRowsPerPageOptions"
          [paginator]="!isHourlyView"
          [rows]="isHourlyView ? hourlyTableRows : rows"
          [first]="first"
          [lazy]="false"
          [showCurrentPageReport]="consumptionsTableShowCurrentPageReport && !isHourlyView"
          [showPageLinks]="consumptionsTableShowPageLinks && !isHourlyView"
          [showFirstLastIcon]="consumptionsTableShowFirstLastIcon && !isHourlyView"
          [paginatorStyleClass]="consumptionsTablePaginatorStyleClass"
          sortField="consumptionDate"
          [sortOrder]="-1"
          (onPage)="onConsumptionsPage($event)"
          currentPageReportTemplate="{last} de {totalRecords}"
        >
          <ng-template pTemplate="header" let-columns>
            <tr>
              <th
                style="width: 25%"
                [class.text-center]="isHourlyView"
                pSortableColumn="consumptionDate"
                field="consumptionDate"
              >
                @if (isHourlyView) {
                  Hora
                } @else {
                  Fecha
                }
                <p-sortIcon field="consumptionDate" />
              </th>
              <th
                style="width: 25%"
                class="text-center"
                pSortableColumn="readingValue"
                field="readingValue"
              >
                @if (isNarrowViewport()) {
                  Lect.
                } @else {
                  Lectura {{ dailyConsumptionsUnits() }}
                }
                <p-sortIcon field="readingValue" />
              </th>
              <th
                style="width: 25%"
                class="text-center"
                pSortableColumn="consumptionValue"
                field="consumptionValue"
              >
                @if (isNarrowViewport()) {
                  Cons.
                } @else {
                  Consumo {{ dailyConsumptionsUnits() }}
                }
                <p-sortIcon field="consumptionValue" />
              </th>
              <th style="width: 25%" class="text-center">Tipo lectura</th>
            </tr>
          </ng-template>
          <ng-template
            pTemplate="body"
            let-consumption
            let-columns="columns"
            let-rowIndex="rowIndex"
          >
            <tr
              [pSelectableRow]="consumption"
              [pSelectableRowIndex]="rowIndex"
              [class.daily-readings-row-estimated]="isEstimatedReadingType(consumption.readingType)"
            >
              <td
                class="text-break"
                [class.text-center]="isHourlyView"
                [class.daily-readings-table-td-fixed]="useFixedDailyConsumptionsTableRowHeight()"
              >
                @if (isHourlyView) {
                  {{ formatHourFromConsumptionDate(consumption.consumptionDate) }}
                } @else {
                  {{ dateSpanishFormat(consumption.consumptionDate) }}
                }
              </td>
              <td
                class="text-break text-center"
                [class.daily-readings-table-td-fixed]="useFixedDailyConsumptionsTableRowHeight()"
              >
                {{
                  formatMeteringTableAmount(
                    consumption.readingValue,
                    isEmptyConsumptionRow(consumption),
                    readingAmountDecimals()
                  )
                }}
              </td>
              <td
                class="text-break text-center"
                [class.daily-readings-table-td-fixed]="useFixedDailyConsumptionsTableRowHeight()"
              >
                {{
                  formatMeteringTableAmount(
                    consumption.consumptionValue,
                    isEmptyConsumptionRow(consumption),
                    3
                  )
                }}
              </td>
              <td
                class="text-break text-center"
                [class.daily-readings-table-td-fixed]="useFixedDailyConsumptionsTableRowHeight()"
              >
                {{ formatReadingType(consumption.readingType) }}
              </td>
            </tr>
          </ng-template>
          <ng-template #emptymessage>
            <tr>
              <td [attr.colspan]="tableColumnCount">Ningun resultado encontrado.</td>
            </tr>
          </ng-template>
        </p-table>
      </p-card>
    </div>
  </main>
</div>
